module.exports = __webpack_public_path__ + "img/orange-noti.83fdc536.svg";